// shared/lib/tokens/env.token.ts
import { InjectionToken } from '@angular/core';

// Replace `any` with a proper interface for your env shape if you like
export const ENV_CONFIG_UM = new InjectionToken<Record<string, any>>('ENV_CONFIG_UM');
